import { PlaceFeaturesView, PlaceTab } from './place-details.types'
import { AccessControlTabSkeleton } from './tabs/access-control'
import { FeaturesTabSkeleton } from './tabs/features'
import { GeneralTabSkeleton } from './tabs/general'
import { LanguagesTabSkeleton } from './tabs/languages'
import { OtherTabSkeleton } from './tabs/other'
import { PmsTabSkeleton } from './tabs/pms'

interface PlaceTabSkeletonProps {
  activeTab: PlaceTab
  isAdmin: boolean
  featuresView?: PlaceFeaturesView
}

// Note: credentials and perks only need the building id, so the page renders them for real
export const PlaceTabSkeleton = ({ activeTab, featuresView, isAdmin }: PlaceTabSkeletonProps) => {
  switch (activeTab) {
    case PlaceTab.accessControl:
      return <AccessControlTabSkeleton isAdmin={isAdmin} view={featuresView} />
    case PlaceTab.features:
      return <FeaturesTabSkeleton isAdmin={isAdmin} view={featuresView} />
    case PlaceTab.languages:
      return <LanguagesTabSkeleton />
    case PlaceTab.other:
      return <OtherTabSkeleton />
    case PlaceTab.pms:
      return <PmsTabSkeleton />
    default:
      return <GeneralTabSkeleton isAdmin={isAdmin} />
  }
}
